import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import * as animations from "@styles/emotion-styles/animations";
import * as dimensions from "@styles/emotion-styles/dimensions";
import * as layers from "@styles/emotion-styles/layers";

export const overlay = {
  base: (theme: Theme) => css`
    animation: ${animations.fadeInOverlay} 0.3s ${animations.easeOutCubic};
    background-color: ${theme.text.emphasis};
    opacity: 0;
    position: fixed;
    display: none;
    width: 100vw;
    height: 100vh;
    top: 0;
    cursor: pointer;
    z-index: ${layers.indexOverlay};
  `,
  active: css`
    display: block;
    opacity: 0.6;

    @media only screen and (min-width: ${dimensions.desktop}) {
      display: none;
    }
  `,
};
